export default "__VITE_ASSET__670987fd__"